export default __webpack_public_path__ + "static/media/Laurie_Flasko_AHV_In_Moms_We_Trust.87107231.jpg";